import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-base-200 text-base-content">
      <div className="text-center">
        <h1 className="text-9xl font-bold font-display text-primary">404</h1>
        <p className="text-lg opacity-60">Oops! The page you&apos;re looking for doesn&apos;t exist.</p>
        <button onClick={handleGoHome} className="btn btn-primary shadow-glow mt-6">
          Go to Home
        </button>
      </div>
      <div className="mt-12 flex space-x-4">
        <div className="w-8 h-8 bg-primary rounded-full animate-bounce" />
        <div className="w-8 h-8 bg-info rounded-full animate-bounce delay-200" />
        <div className="w-8 h-8 bg-error rounded-full animate-bounce delay-400" />
      </div>
    </div>
  );
};

export default NotFound;
